import axiosPost from "./axiosPost";

export const RNHDepartamentoGet = async (credentials, data) => {
    const body = {
        service: "RNHDepartamentoGet",
        params: {
            rnhDepartamentoId: data?.id || null,
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
